import React, { FC } from 'react';

export const SidebarRightContent: FC<{ className?: string }> = ({ className, children }) => {
  return <div className={`sidebar-right-content pt-3 flex flex-col flex-grow ${className}`}>{children}</div>;
};
